import React from 'react';
import '../assets/css/about.css';

const AboutSection = () => {
  return (
    <section id="about" className="about-section section-breakpoint">
      <div className="container">
        <h1 className="heading">
          <span className="first-line">Breakspoll is a global</span> celebration of breakbeat music. Starting in 2001 as an online poll among
          breakbeat enthusiasts, breakspoll evolved into a major event, recognising the very best DJs, producers,
          events and more from across the breakbeat scene.
        </h1>
      </div>
    </section>
  );
};

export default AboutSection;
